import { render, staticRenderFns } from "./attachmentsViewer.vue?vue&type=template&id=11c73ca6&scoped=true&"
import script from "./attachmentsViewer.vue?vue&type=script&lang=js&"
export * from "./attachmentsViewer.vue?vue&type=script&lang=js&"
import style0 from "./attachmentsViewer.vue?vue&type=style&index=0&id=11c73ca6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c73ca6",
  null
  
)

export default component.exports